import React, { Component } from 'react';

class Search extends Component {
	constructor(props)
	{
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}
	handleChange(e) {
		this.props.onSearch(e.target.value);
	}
	render() {
		return (
			<form className="form">

				<div className="form__fields">

					<div className="form-control form-control--horizontal elementary">

						<div className="form-control__label">

							<label className="label" htmlFor="resource-search">Search for a resource</label>

						</div>

						<div className="form-control__field">

							<input type="search" name="resource-search" id="resource-search" placeholder="What are you looking for?" className="field" onChange={this.handleChange} />

						</div>

					</div>

				</div>

			</form>
		);
	}
}

export default Search;
